/*
 | ======================================================
 | This File is for Uploading file(s) API services handling
 | ======================================================
 */

import { ApiService } from './api.service'

class EnergyBillUploadService {
  constructor () {
    this.request = new ApiService('alternativemedia')
  }

  /*
   * New file upload API service
   * @param formData
   * Math random is added to avoid cache issue on parallel upload
   * @returns {*}
   */
  new = formData => {
    return this.request.post('/eng/front/bill-file-upload', formData)
  }
}

export default EnergyBillUploadService
